/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StorefrontScanResponseDTOFromJSON, StorefrontScanResponseDTOToJSON, } from './StorefrontScanResponseDTO';
/**
 * Check if a given object implements the PaginatedResponseStorefrontScanResponseDTO interface.
 */
export function instanceOfPaginatedResponseStorefrontScanResponseDTO(value) {
    return true;
}
export function PaginatedResponseStorefrontScanResponseDTOFromJSON(json) {
    return PaginatedResponseStorefrontScanResponseDTOFromJSONTyped(json, false);
}
export function PaginatedResponseStorefrontScanResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(StorefrontScanResponseDTOFromJSON)),
    };
}
export function PaginatedResponseStorefrontScanResponseDTOToJSON(json) {
    return PaginatedResponseStorefrontScanResponseDTOToJSONTyped(json, false);
}
export function PaginatedResponseStorefrontScanResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(StorefrontScanResponseDTOToJSON)),
    };
}
